module.exports = __webpack_public_path__ + "img/vam.c108edba.png";